import { Button, Typography, styled as muiStyled } from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const MediaButton = muiStyled(Button)(() => ({
  padding: '4px 8px',
  height: '26px',
  borderRadius: '4px',
  fontSize: '1.2rem',
  background: abyssColors.neutral[50],
  color: abyssColors.primary[500],
  fontWeight: 600,
  boxShadow: 'none',
  textTransform: 'none',
  border: `1px solid ${abyssColors.primary[500]} !important`,
}));

export const MediaButtonLabel = muiStyled(Typography)(() => ({
  color: abyssColors.primary[500],
  fontWeight: 600,
  fontSize: '1.2rem',
  margin: '0 6px',
}));
